namespace GeniuzPOS.Member {
    export interface MbProvinceLookupRow {
        MbProvince?: string;
        MbAmphur?: string;
        MbTumbol?: string;
    }

    export namespace MbProvinceLookupRow {
        export const idProperty = 'MbProvince';
        export const nameProperty = 'MbProvince';
        export const localTextPrefix = 'Member.MbProvinceLookup';
        export const lookupKey = 'Member.MbProvinceLookup';

        export function getLookup(): Q.Lookup<MbProvinceLookupRow> {
            return Q.getLookup<MbProvinceLookupRow>('Member.MbProvinceLookup');
        }
        export const deletePermission = null;
        export const insertPermission = null;
        export const readPermission = '';
        export const updatePermission = null;

        export declare const enum Fields {
            MbProvince = "MbProvince",
            MbAmphur = "MbAmphur",
            MbTumbol = "MbTumbol"
        }
    }
}
